<template>
    <div>
        <MainlayoutLogin></MainlayoutLogin>
        <!-- <div v-if="user">
            <MainlayoutLogin></MainlayoutLogin>
     
    </div>
    <div v-else>
        <Mainlayout></Mainlayout>
    </div> -->
                  
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 15%; position: relative;">
                            <h1 class="font-general-sans text-center custom-54px-400" data-aos="fade-left">
                                Unlock Your Potential with Interviewrr:
                            </h1>
                            <h3 class="custom-54px-600 font-general-sans text-center" data-aos="fade-right">Your Gateway to Interview Success</h3>
                            <div class="responsive-card">
                                <CCard class="border-radius-16px p-4" data-aos="zoom-in">
                                    <img src="../assets/img/Input.png" style="max-width: 100%;" class="" />
                                    <h3 class="ccustom-18xp-500 text-black font-general-sans text-center mt-4">Prepare Your Interview with Us</h3>
                                    <p class="custom-14px-500 font-color-AEAEB2 text-center">Record Yourself and Check in Real Time</p>
                                    <span class="border-radius-24px font-general-sans text-center" @click="GotoHowItWork()">Start</span>
                                </CCard>
                            </div>
    
                            <!-- <label class="bottom-right-button-text"><strong><b>Are you a company looking for talent?</b></strong></label>
                            <br />
                            <button class="bottom-right-button" @click="OpenCalendly()"><label class="custom-16px-700 text-white">Book a Tour</label>
                                <br />
                               <label class="custom-12px-700 text-white">Powered by Calendly</label> </button>
     -->
    
    
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        
        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all">
            <div class="popup-all2">
                <!-- Popup content -->
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/interest.png" />
                    <h3 class="custom-32px-500">Register Your Interest!</h3>
                    <h3 class="custom-16px-400 text-center">Dear User, currently our slots for this feature are fully occupied. If you want this feature to assist you, please register. If slots become available, we will notify you via email</h3>
    
                    <h3 class="custom-14px-500 mt-4 text-left">Add Me To The List</h3>
                    <input type="text" v-model="emailinterest" class="custom-input-app" placeholder="test@gmail.com" />
                </div>
                <div class="text-center mt-4">
                    <span class="custom-border-purple p-2 text-center text-white pr-2 pl-2" @click="OpenPopup()">Submit</span>
                </div>
            </div>
        </div>
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <!-- <div :class="popupClass"> -->
                <div class="popup-all1">
                    <div class="text-right">
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" class="text-right" />
            </div>
                <CTabs v-model="activetab" variant="pills" class="custom-tabs">
                    <CTab title="Record Interview" name="Career" @click="setActiveTab('Career')" class="custom-tab">
                       <div class="custom-scroll">
      <div style="width: 80%;background-size: cover; margin: auto;">
        <div class="m-0">
                            <div class="text-center">
                                <h3 class="custom-16px-500 mt-1 text-center mt-3">Career Path Selection</h3>
                                <h3 class="custom-16px-400 text-center">Help tailor the interview questions and feedback to your specific career goals and aspirations</h3>
                                <h3 class="custom-14px-500 mt-1 text-left">Your current field Of Expertise</h3>
                                <v-select v-model="selectedPosition" :options="positionOptions" label="Name"></v-select>
    
                                <h3 class="custom-14px-500 mt-1 text-left">Field For the Interview</h3>
                                <v-select v-model="selectedPosition1" :options="positionOptions" label="Name"></v-select>
                                <h3 class="custom-16px-400 text-left">which can be the same or different from your current field</h3>

                                <h3 class="custom-14px-500 text-left">Company Code</h3>
                                <h3 class="custom-16px-400 text-left"><input type="checkbox" class="mr-2" v-model="companyCode"/>if you have code from company that request for personal video interview</h3>
                                <div v-if="this.ErrorPosition == true" class="mt-1">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error: Please fill in the form position</strong>
                                                </CAlert>
                                            </div>

                                
                                <div v-if="this.ErrorCode == true" class="mt-1">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2"></strong> {{ Message }} Please try insert new code.
                                                </CAlert>
                                            </div>

                                            <div v-if="this.ShowCode == true" class="mt-1">
                                                <CAlert show color="success">
                                                    <strong class="text-danger mr-2"></strong> {{ Message }}
                                                </CAlert>
                                            </div>
                            </div>
                                <div v-if="companyCode">
                                    <CAlert color="danger" class="mb-2" v-if="codeCompany === ''">Note : Please input your code</CAlert>
        <div class="input-container">
    <CInput type="text" v-model="codeCompany" class="custom" placeholder="Enter code..."/>
    <CButton type="button" class="verify-button" @click="VerifyCodeData()">Verify</CButton>
  </div>
</div>
 
                            <!-- <div class="text-center mt-2">
                                <span
        class="custom-border-purple p-2 text-center text-white pr-2 pl-2"
        :class="{ 'disabled': ErrorCode }"
        @click="ErrorCode ? null : OpenFormVideo()"
    >
        Submit
    </span>
                            </div> -->

                            <div class="text-center mt-2">
                                <span
        class="custom-border-purple p-2 text-center text-white pr-2 pl-2"
        @click="OpenFormVideo()"
    >
        Submit
    </span>
                            </div>
                        </div>
                    </div>
                        </div>
                    </CTab> </CTabs>
            </div>
        </div>
    
    
        <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Congratulations ! You have been placed in the Early Bord Candidate Benefit program, where you will be entitled to receive five free submissions once the feature becomes available.As an early bird, you're already ahead of the curve!
                    </h3>
                </div>
                <CButton class="button-border-202020" @click="closePopup2" block><span class="ml-2 mr-2">Close</span></CButton>
            </div>
        </div>
    
    
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

  import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/all/banner.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },
  
    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            name: "",
            email: "",
            phone: "",
            password: "",
            selectedUser: "",


            isLanguagePopupVisible: false,
            emailinterest: "",

            selectedExpertise: "",
            selectedField: "",
            //selectedPosition: "",
            expertiseOptions: [], // Initialize as an empty array
            fieldOptions: [], // Initialize as an empty array
            positionOptions: [],
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            Names: "",
            activetab: "",
            isLoved: false, // Initial state
            filter: false,
            hideColumn: true,

            isCategoryListVisible: true, // Toggle state
            isTypeListVisible: false,
            isCategorySeniorityVisible: false,
            categoryJob: [],
            categoryJobType: [],
            categoryJobSeniority: [],
            isLoved: false, // Initial state
            progressBarValue: 50, // Initial value (percentage)
      minSalary: 50000,    // Example minimum salary
      maxSalary: 100000,   // Example maximum salary
      companyCode: false,
      codeCompany: '',
      ErrorCode: false,
      ShowCode: false,
      Message: "",
      result: {},
      selectedPosition: '',
      ErrorPosition: false,
      user: null,
      Names: "",
        };
        
    },
    created() {
        AOS.init();
      
    },

    mounted() {
        this.getListField();
        this.getListExpertise();
        this.getListPosition();
        this.GetListCategoryJob();
        this.GetListCategoryJobType();
        this.GetListCategoryJobSeniority();

       

   
    },
    computed: {
        popupClass() {
            return this.activetab === 'Career' ? 'popup-all1' : 'popup-all2';
        },
        progressBarWidth() {
      return `${this.progressBarValue}%`; // Convert value to percentage for width
    },
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Index");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Index");
                console.error("Error fetching user info:", error);
            }
        },
       
        OpenFilter() {
           // this.filter = true;
           // this.hideColumn = false;

            this.filter = !this.filter;
            this.hideColumn = !this.hideColumn;
        
        },
        setActiveTab(tabName) {
            this.activetab = tabName;
        },

       
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            //  this.$router.push("HowItWork");
            this.isLanguagePopupVisible1 = true;
        },
        OpenHowItWork() {
            this.$router.push("HowItWork");
        },
        GoToLogin() {
            this.$router.push("Login");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup1() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup2() {
            this.isLanguagePopupVisible1 = false;
            this.isLanguagePopupVisible2 = false;
        },
        OpenPopup() {
            this.isLanguagePopupVisible = false;
            this.isLanguagePopupVisible1 = true;

        },
        SubmitData() {

            

            const formData = new FormData();

            formData.append("email", this.emailinterest);
            formData.append("experties", this.selectedExpertise.Name);
            formData.append("field", this.selectedField.Name);


            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.isLanguagePopupVisible1 = false;
                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenFormVideo() {
            if (!this.selectedPosition || !this.selectedPosition.Name) 
            {
                this.Message = 'Please select your current field';
                    this.ErrorPosition = true;
            }
            else
            {
                if(this.ErrorCode === true){
                    this.ErrorPosition = false;
                    this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)
                }
                else
                {
                    if(this.codeCompany === '')
                    {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)

                    }
                    else
                    {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name + "&code=" + this.codeCompany)
                    }
                   
                }
               
           
            }
        },
        async getListField() {
            try {
                const response = await this.$API.get(this.$GetListField);
                if (response.status === 200) {
                    this.fieldOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListExpertise() {
            try {
                const response = await this.$API.get(this.$GetListExpertise);
                if (response.status === 200) {
                    this.expertiseOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListPosition() {
            try {
                const response = await this.$API.get(this.$GetListPosition);
                if (response.status === 200) {
                    this.positionOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        OpenCalendly() {
            window.open("https://calendly.com/rasid-interviewrr");
        },
        toggleLove() {
            this.isLoved = !this.isLoved;
        },
        async GetListCategoryJob() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJob);
                if (response.status === 200) {
                    this.categoryJob = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleCategoryList() {
            this.isCategoryListVisible = !this.isCategoryListVisible;
        },

        async GetListCategoryJobType() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobType);
                if (response.status === 200) {
                    this.categoryJobType = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleTypeList() {
            this.isTypeListVisible = !this.isTypeListVisible;
        },

        async GetListCategoryJobSeniority() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobSeniority);
                if (response.status === 200) {
                    this.categoryJobSeniority = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleSeniorityList() {
            this.isCategorySeniorityVisible = !this.isCategorySeniorityVisible;
        },
        async VerifyCodeData() {
        try {
            this.ErrorPosition = false;
            const codeCompany1 = this.codeCompany;
            const response = await this.$API.get(this.$VerifyCode + '?code=' + codeCompany1); // Assuming this.$VerifyCode is your API endpoint URL
            
            if (response.status === 200) {
                this.result = response.data;
                if (this.result === 'The code is not ready for used.') {
                    this.Message = 'The code is not ready for used.';
                    this.ErrorCode = true;
                    
                } else if (this.result === 'The code is expired.') {
                    this.Message = 'The code is expired.';
                    this.ErrorCode = true;
                } else if (this.result === 'The code is invalid.') {
                    this.Message = 'The code is invalid.';
                    this.ErrorCode = true;
                } else {
                    this.Message = response.data
                    this.ShowCode = true;
                    this.ErrorCode = false;
                 
            }
            } else {
                // Handle non-200 status code
                console.error('Failed to fetch data:', response.statusText);
            }
        } catch (error) {
            // Handle the error here
            console.error('Error fetching data:', error);
        }
    }





    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

.overlay-text {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    left: 20px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    color: white;
    padding: 10px;
    text-align: center;
    font-size: 1.2em;
    /* Adjust as needed */
    width: 70%;
    margin: 0 auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height:90vh;
}
.salary-range {
  padding: 20px;
}

.progress {
  height: 20px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #007bff;
}

.custom-range {
  width: 100%;
}

.input-container {
  position: relative;
  display: inline-block;
  width:100%;
}

input[type="text"].custom {
  padding-right: 60px; /* Adjust according to button width */
  height:80px;
}

.verify-button {
  position: absolute;
  right: 2px;
  top: 3px;
  bottom:3px;
  height: 28px;
  border-radius: 50px;
  background: #928AFD;
  color:#fff;
  /* Optional: Adjust the button height to match the input field */
}
.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>